import ForgotPasswordPage from './ForgotPasswordPage';
export { ForgotPasswordPage };
export default ForgotPasswordPage;
